exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-7b7b07cd]{margin-top:35px}.handle[data-v-7b7b07cd]{float:left}.close[data-v-7b7b07cd],.handle[data-v-7b7b07cd]{padding-top:8px;padding-bottom:8px}.close[data-v-7b7b07cd]{float:right}input[data-v-7b7b07cd]{display:inline-block;width:50%}.text[data-v-7b7b07cd]{margin:20px}", ""]);

// exports
